/* eslint-disable no-console */
import React from "react";
import { Document, Page, Text, View, Image, Link } from "@react-pdf/renderer";

const PdfReporteFotografico = ({ slides, selectedSale, edificioImages }) => {
  const totalPantallasFor = (edificio) => (edificio.pantallas || 0) + (edificio.totems || 0) + (edificio.espera || 0);

  return (
    <Document>
      {slides.map(({ foto, edificio }, idx) => {
        const edImg = edificioImages[edificio.id];
        const totalPantallas = totalPantallasFor(edificio);

        return (
          <Page
            key={foto.id}
            size="A4"
            orientation="landscape"
            style={{ flexDirection: "row", backgroundColor: "#f8f9fa", fontFamily: "Helvetica" }}
          >
            {/* Media principal - lado izquierdo. Foto → <Image>; video con póster → el
                frame como <Image> (mismo layout que foto); video sin póster → placeholder
                con link (el <Image> no puede decodificar mp4 y dejaba la página coja). */}
            <View style={{ flex: 1, padding: 20, justifyContent: "center", alignItems: "center" }}>
              {foto.tipo === "video" && !foto.poster_url ? (
                <View
                  style={{
                    borderWidth: 1,
                    borderColor: "#dee2e6",
                    borderRadius: 8,
                    backgroundColor: "#fff",
                    padding: "20px 24px",
                    alignItems: "center",
                  }}
                >
                  <Text style={{ fontSize: 16, fontWeight: 700, color: "#2ce67c", marginBottom: 8 }}>VIDEO</Text>
                  <Text style={{ fontSize: 9, color: "#6c757d", textAlign: "center", marginBottom: 10 }}>
                    Ver en el reporte online
                  </Text>
                  <Link src={foto.url} style={{ fontSize: 8, color: "#0d6efd", textAlign: "center" }}>
                    {foto.url}
                  </Link>
                </View>
              ) : (
                <Image
                  src={foto.tipo === "video" ? foto.poster_url : foto.url}
                  style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                />
              )}
            </View>

            {/* Ficha técnica - lado derecho */}
            <View style={{ width: 260, padding: 20, justifyContent: "flex-start" }}>
              {/* Header info de la venta */}
              <View
                style={{
                  backgroundColor: "#fff",
                  borderRadius: 8,
                  border: "1px solid #dee2e6",
                  marginBottom: 12,
                  overflow: "hidden",
                }}
              >
                {/* Barra verde con nombre edificio */}
                <View style={{ backgroundColor: "#2ce67c", padding: "8px 10px", alignItems: "center" }}>
                  <Text style={{ fontSize: 12, fontWeight: 700, color: "#000" }}>{edificio.edificio}</Text>
                </View>

                {/* Dirección */}
                {edificio.direccion && (
                  <View style={{ padding: "6px 10px" }}>
                    <Text style={{ fontSize: 8, color: "#6c757d", textAlign: "center" }}>
                      {edificio.direccion}
                      {edificio.ubicacion ? `, ${edificio.ubicacion}` : ""}
                    </Text>
                  </View>
                )}

                {/* Personas y pantallas */}
                {(edificio.personas || totalPantallas > 0) && (
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "center",
                      gap: 24,
                      padding: "8px 0",
                      borderTop: "1px solid #eee",
                    }}
                  >
                    {edificio.personas && (
                      <View style={{ alignItems: "center" }}>
                        <Text style={{ fontSize: 18, fontWeight: 700, color: "#2ce67c" }}>
                          {Number(edificio.personas).toLocaleString("es-CL")}
                        </Text>
                        <Text style={{ fontSize: 6, textTransform: "uppercase", color: "#999", letterSpacing: 0.5 }}>
                          Personas
                        </Text>
                      </View>
                    )}
                    {totalPantallas > 0 && (
                      <View style={{ alignItems: "center" }}>
                        <Text style={{ fontSize: 18, fontWeight: 700, color: "#2ce67c" }}>{totalPantallas}</Text>
                        <Text style={{ fontSize: 6, textTransform: "uppercase", color: "#999", letterSpacing: 0.5 }}>
                          Pantallas
                        </Text>
                      </View>
                    )}
                  </View>
                )}

                {/* Imagen exterior del edificio */}
                {edImg && (
                  <View style={{ height: 160, overflow: "hidden" }}>
                    <Image src={edImg} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </View>
                )}
              </View>

              {/* Info de la venta */}
              <View style={{ backgroundColor: "#fff", borderRadius: 8, border: "1px solid #dee2e6", padding: 10 }}>
                {selectedSale.cliente && (
                  <View style={{ marginBottom: 4 }}>
                    <Text style={{ fontSize: 7, color: "#6c757d" }}>Cliente</Text>
                    <Text style={{ fontSize: 9, fontWeight: 700 }}>{selectedSale.cliente}</Text>
                  </View>
                )}
                {selectedSale.campana && (
                  <View style={{ marginBottom: 4 }}>
                    <Text style={{ fontSize: 7, color: "#6c757d" }}>Campa&ntilde;a</Text>
                    <Text style={{ fontSize: 9, fontWeight: 700 }}>{selectedSale.campana}</Text>
                  </View>
                )}
                {selectedSale.periodopauta && (
                  <View>
                    <Text style={{ fontSize: 7, color: "#6c757d" }}>Per&iacute;odo</Text>
                    <Text style={{ fontSize: 9, fontWeight: 700 }}>{selectedSale.periodopauta} d&iacute;as</Text>
                  </View>
                )}
              </View>

              {/* Pie de página */}
              <Text style={{ fontSize: 7, color: "#aaa", textAlign: "center", marginTop: 8 }}>
                Foto {idx + 1} de {slides.length}
              </Text>
            </View>
          </Page>
        );
      })}
    </Document>
  );
};

export default PdfReporteFotografico;
